<p-toast></p-toast>
<app-feedback-dialog
    [showdialog]="showdialog"
    [selectedChatInteraction]="selectedChatInteraction"
    [like]="likeDialog"
    (emitUserFeedback)="submitUserFeeback($event)"
    (closeDialog)="closeDialog($event)"
>
</app-feedback-dialog>
<app-code-dialog
    [showdialog]="showCodeDialog"
    [selectedChatInteraction]="selectedChatInteraction"
    [responseIndex]="selectedIndex"
    (closeDialog)="closeCodeDialog($event)"
>
</app-code-dialog>
<div #scrollContainerResponse
    class="flex"
    *ngIf="
        (interaction['response'][responseIndex]['text'] !== '' ||
            lastInteraction ||
            interaction.response[responseIndex].chart) &&
        !hideResponse
    "
>
    <!-- Logic to see previous responses spawns upon regeneration -->
    <div
        [ngClass]="interaction?.response?.length > 1 ? '' : 'visbilityHidden'"
        class="flexEnd respNavigation"
    >
        <div class="flex align-items-center">
            <button
                type="button"
                [ngClass]="responseIndex === 0 ? 'greyIcon' : ''"
                (click)="responseHistory(true)"
                class="icon-btn"
            ><i class="bi bi-chevron-left mr-0"></i></button>
            <p class="interactionCount p-0">
                {{ responseIndex + 1 }}/{{ interaction.response.length }}
            </p>
            <button
                type="button"
                [ngClass]="
                    interaction?.response?.length - 1 === responseIndex
                        ? 'greyIcon'
                        : ''
                "
                (click)="responseHistory(false)"
                class="icon-btn"
            ><i class="bi bi-chevron-right ml-0"></i></button>
        </div>
    </div>

    <!-- Logic to render response -->

    <div class="reply ml-2">

        <!-- Logic to show loaders  -->
        @if(interaction.chatStatus === chatStatusWaiting && chatType !== deepResearchChatType){
            @if(chatType === quiltChatType || isStructuredChat || (showCursor && (!chatReply || chatReply === '') && (!typewriterReasoningSummaryText?.length) && (!typewriterProgressSummaryText?.length))){
                <div
                    class="response-loader"
                >
                    <app-chat-response-loader
                        [progressStatus]="interaction?.progressStatus"
                    />
                </div>
            }
        }

        

        <div>
            <!-- Logic to show reasoning summary-->
            <div *ngIf="typewriterReasoningSummaryText?.length">
                <div class="llm-events-summary-collapsible">
                    <details [open]="false">
                        <summary class="llm-events-header">Reasoning Summary</summary>
                        <div class="llm-events-body typewriter" [markdown]="typewriterReasoningSummaryText"></div>
                        <ng-container *ngFor="let reasoningSummary of [typewriterReasoningSummaryText]; let i = index">
                            <div class="progress-body llm-events-body typewriter" markdown>
                                {{ reasoningSummary }}
                            </div>
                        </ng-container>
                        <hr *ngIf="interaction.chatStatus !== chatStatusWaiting">
                    </details>
                </div>
            </div>
            

            <!-- Progress Summary for Deep Research-->
            <div *ngIf="typewriterProgressSummaryText?.length">
                <div class="llm-events-summary-collapsible">
                    <details [open]="false">
                        <summary class="llm-events-header">🔍 Research Progress</summary>
                        <ng-container *ngFor="let progressSummary of [typewriterProgressSummaryText]; let i = index">
                            <div class="progress-body llm-events-body typewriter" markdown>
                                {{ progressSummary }}
                            </div>
                        </ng-container>
                        <hr *ngIf="interaction.chatStatus !== chatStatusWaiting">
                    </details>
                </div>
            </div>

            <div *ngIf="interaction.chatStatus === chatStatusWaiting && chatservice.chatType === deepResearchChatType">
                <div class="typewriter-text">
                    <span>
                        Deep Research in progress, this might take several minutes...
                    </span>
                </div>
            </div>

            <!-- Logic to handle response text - string type (If response is [] we add text as empty string)  -->
            <div
                #responseText
                class="typewriter-text"
                *ngIf="
                    (interaction.chatStatus !== chatStatusWaiting || chatReply) &&
                    (interaction.response[responseIndex]?.text ||
                        interaction.response[responseIndex]?.text === '')
                "
            >
                <div>
                    <div
                        *ngFor="
                            let codelines of typewriterText?.split('```');
                            let i = index
                        "
                    >
                        <div *ngIf="i % 2 === 0">
                            <div class="typewriter">
                                <div [markdown]="true">{{ codelines }}</div>
                            </div>
                        </div>
                        <div class="my-3 codeContainer" *ngIf="i % 2 !== 0">
                            <app-ace-editor
                                [code]="codelines.split('\n').slice(1).join('\n')"
                                [language]="codelines.split('\n')[0]"
                            ></app-ace-editor>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="
                        interaction['response'][responseIndex]['chart'] &&
                        !isArray(interaction['response'][responseIndex]['chart'])
                    "
                >
                    <app-charts
                        [chatResp]="interaction['response'][responseIndex]"
                    ></app-charts>
                </div>
                <div
                    class="chart-container"
                    *ngIf="
                        interaction['response'][responseIndex]['chart'] &&
                        isArray(interaction['response'][responseIndex]['chart'])
                    "
                >
                    <ng-container
                        *ngFor="
                            let chartUrl of interaction['response'][responseIndex][
                                'chart'
                            ];
                            let idx = index
                        "
                    >
                        <ng-container *ngIf="chatImages[idx]; else loading">
                            <button
                                type="button"
                                class="image-container icon-btn"
                                (click)="displayModal = true"
                            >
                                <div class="image-scrollable">
                                    <img alt="Chart" [src]="chatImages[idx]" />
                                </div>
                                <a
                                    [href]="chatImages[idx]"
                                    class="download-btn"
                                    [attr.download]="chartUrl"
                                    (click)="downloadImage($event)"
                                >
                                    <i class="bi bi-download p-0 m-0"></i>
                                </a>
                            </button>
                            <p-dialog
                                header=""
                                [(visible)]="displayModal"
                                [draggable]="false"
                                [modal]="true"
                                class="custom-dialog"
                                [closable]="false"
                            >
                                <ng-template pTemplate="header">
                                    <div
                                        class="custom-dialog-header flex just justify-content-end"
                                    >
                                        <a
                                            [href]="chatImages[idx]"
                                            (click)="downloadImage($event)"
                                            class="dialogIconContainer mr-2"
                                            [attr.download]="chartUrl"
                                            ><i class="pi pi-download m-1"></i
                                        ></a>
                                        <button
                                            type="button"
                                            class="dialogIconContainer icon-btn"
                                            (click)="displayModal = false"
                                        >
                                            <i class="pi pi-times m-1"></i>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                    <img
                                        [src]="chatImages[idx]"
                                        alt="Visuals Uploaded in Chat"
                                        class="custom-image"
                                    />
                                </ng-template>
                            </p-dialog>
                        </ng-container>
                        <ng-template #loading>
                            <div
                                class="image-loader flex justify-content-center align-items-center"
                            >
                                <p-progressSpinner
                                    styleClass="w-3rem h-3rem"
                                    strokeWidth="2"
                                    animationDuration=".6s"
                                ></p-progressSpinner>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
                <span *ngIf="showCursor" class="cursor">|</span>
            </div>

            <!-- UI Element to display Response Table and Chart-->
            @if (   interaction.response[responseIndex]?.responseTables?.length > 0 &&
                    interaction.response[responseIndex]?.responseTables[0].rows.length > 1 &&
                    !showTypeWriter) {
                <div class="response-table-chart">
                    <app-chat-response-table-chart
                        [chatResponse]="currentResponse"
                    />
                </div>
            }

        </div>

        <!-- Logic to handle response segments - Array of IResponseSegments -->
        <ng-container
            *ngIf="
                interaction.response[responseIndex]?.responseSegments?.length >
                    0 && interaction.chatStatus !== chatStatusWaiting
            "
        >
            <div #responseText class="typewriter-text">
                <ng-container
                    *ngFor="
                        let segment of interaction.response[responseIndex]
                            .responseSegments;
                        let idx = index
                    "
                >
                    <ng-container *ngIf="segment.type === textType">
                        <div class="typewriter">
                            <div [markdown]="true">{{ segment.data }}</div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="segment.type === codeType">
                        <div class="my-3 codeContainer">
                            <app-ace-editor
                                [code]="
                                    segment?.data
                                        .split('\n')
                                        .slice(1)
                                        .join('\n')
                                "
                                [language]="segment?.data?.split('\n')[0]"
                            ></app-ace-editor>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="segment.type === imageType">
                        <div
                            class="chart-container"
                            *ngIf="chatImages[idx]; else loading"
                        >
                            <button
                                type="button"
                                class="image-container icon-btn"
                                (click)="displayModal = true"
                            >
                                <div class="image-scrollable">
                                    <img [src]="chatImages[idx]" alt="Chart"/>
                                </div>
                                <a
                                    [href]="chatImages[idx]"
                                    class="download-btn"
                                    [attr.download]="segment.data"
                                    (click)="downloadImage($event)"
                                >
                                    <i class="bi bi-download p-0 m-0"></i>
                                </a>
                            </button>
                            <p-dialog
                                header=""
                                [(visible)]="displayModal"
                                [draggable]="false"
                                [modal]="true"
                                class="custom-dialog"
                                [closable]="false"
                            >
                                <ng-template pTemplate="header">
                                    <div
                                        class="custom-dialog-header flex just justify-content-end"
                                    >
                                        <a
                                            [href]="chatImages[idx]"
                                            (click)="downloadImage($event)"
                                            class="dialogIconContainer mr-2"
                                            [attr.download]="chartUrl"
                                            ><i class="pi pi-download m-1"></i
                                        ></a>
                                        <button
                                            type="button"
                                            class="dialogIconContainer icon-btn"
                                            (click)="displayModal = false"
                                        >
                                            <i class="pi pi-times m-1"></i>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                    <!-- NOSONAR: S6851 - "Image" in alt is intentional for clarity -->
                                    <img
                                        [src]="chatImages[idx]"
                                        alt="Visual Response"
                                        class="custom-image"
                                    />
                                </ng-template>
                            </p-dialog>
                        </div>
                        <ng-template #loading>
                            <div
                                class="image-loader flex justify-content-center align-items-center"
                            >
                                <p-progressSpinner
                                    styleClass="w-3rem h-3rem"
                                    strokeWidth="2"
                                    animationDuration=".6s"
                                ></p-progressSpinner>
                            </div>
                        </ng-template>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>

        <!-- Logic to show icons for feedback, code, download -->


    </div>

</div>

<div class="response-toolbar mb-2" *ngIf="interaction.chatStatus !== chatStatusWaiting">
  <div
      [ngClass]="showCursor ? 'visbilityHidden' : ''"
      *ngIf="
          interaction['response'][responseIndex]['final_code'] &&
          interaction.chatStatus !== chatStatusWaiting
      "
      class="feedback"
  >
      <button
          type="button"
          pTooltip="Show Code"
          tooltipPosition="top"
          (click)="showCode(true)"
          class="icon-btn"
      ><i class="bi bi-code fa-lg codeIcon"></i></button>
  </div>
  <div
      [ngClass]="showCursor ? 'visbilityHidden' : ''"
      *ngIf="
          !interaction['response'][responseIndex]['chart'] &&
          containsTable(interaction.response[responseIndex]) &&
          interaction.chatStatus !== chatStatusWaiting
      "
      class="feedback responseIcons"
  >
      <button
          type="button"
          (click)="
              convertMarkdownToCSV(
                  interaction.response[responseIndex]
              )
          "
          class="icon-btn"
      ><i class="bi bi-download copyIcon"></i></button>
  </div>
  <div
      [ngClass]="showCursor ? 'visbilityHidden' : ''"
      *ngIf="
          interaction['response'][responseIndex]['final_code'] &&
          interaction.chatStatus !== chatStatusWaiting &&
          chatservice.chatType === qecChatType
      "
      class="feedback responseIcons"
  >
      <button
          type="button"
          pTooltip="Download csv"
          tooltipPosition="top"
          *ngIf="!qecDataloader"
          (click)="
              convertJSONtoCSV(interaction.response[responseIndex])
          "
          class="icon-btn"
      ><i class="bi bi-table copyIcon"></i></button>
      <span *ngIf="qecDataloader" class="loaderSpinner"></span>
  </div>
  <div
      *ngIf="
          this.like === undefined &&
          interaction.chatStatus !== chatStatusWaiting
      "
      [ngClass]="showCursor ? 'visbilityHidden' : ''"
      class="feedback"
  >
      <button
          type="button"
          *ngIf="
              !showCopied &&
              !interaction['response'][responseIndex]['chart']
          "
          (click)="copyCode()"
          pTooltip="Copy"
          tooltipPosition="top"
          class="icon-btn"
      ><i class="bi bi-clipboard copyIcon"></i></button>
      <i *ngIf="showCopied" class="bi bi-check2"></i>
      <button
          type="button"
          (click)="feedback(true)"
          pTooltip="Like"
          tooltipPosition="top"
          class="icon-btn"
      ><i class="pi pi-thumbs-up feedbackIcons"></i></button>
      <button
          type="button"
          (click)="feedback(false)"
          pTooltip="Dislike"
          tooltipPosition="top"
          class="icon-btn"
      ><i class="pi pi-thumbs-down dislike feedbackIcons"></i></button>
      @if(showRegenerationButton){
        <button
            type="button"
            class="icon-btn"
            (click)="onRegenerate()"
        ><i class="bi bi-arrow-clockwise"></i></button>
      }
  </div>
  <div
      *ngIf="
          this.like !== undefined &&
          !showCursor &&
          interaction.chatStatus !== chatStatusWaiting
      "
      class="feedback"
  >
      <button
          type="button"
          *ngIf="
              !showCopied &&
              !interaction['response'][responseIndex]['chart']
          "
          (click)="copyCode()"
          pTooltip="Copy"
          tooltipPosition="top"
          class="icon-btn"
      ><i class="bi bi-clipboard copyIcon"></i></button>
      <i *ngIf="showCopied" class="bi bi-check2"></i>
      <i
          *ngIf="this.like"
          pTooltip="Positive"
          tooltipPosition="top"
          class="bi bi-hand-thumbs-up noCursor feedbackIcons like-selected"
      ></i>
      <i
          *ngIf="!this.like"
          pTooltip="Negative"
          tooltipPosition="top"
          class="bi bi-hand-thumbs-down noCursor dislike feedbackIcons dislike-selected"
      ></i>
  </div>
</div>
